module.exports = __webpack_public_path__ + "static/media/furniture-1.290c4ddd.jpg";